export const Event = {
  ASK_BY_VOICE: "askByVocie", // 语音提问
  OPEN_CHANGE_FIEL: "openChangeFile", // 打开文件上传
  REVIEW_UPLOAD: "reviewUpload", // 合同审查上传
  CHOOSE_IMAGE_CALLBACK: "chooseImageCallback", // 选择图片回调
  CHOOSE_IMAGE_CALLBACK_AI: "chooseImageCallbackAI", // 选择图片回调  AI智能生成
  CHOOSE_IMAGE_CALLBACK_LIC: "chooseImageCallbackLic", // 选择图片回调 上传执业执照
};

export const CHOOSE_IMAGE_TYPE = {
  PORTAIT: "1", // 头像
  AI: "2", // AI
  LIC: "3", //  执业执照
};
